import { styled } from '@mui/material/styles';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
import AdminBrand from './AdminBrand';
import AdminMenuContent from './AdminMenuContent';
import AdminUserFooter from './AdminUserFooter';

const DRAWER_WIDTH = 260;

const Drawer = styled(MuiDrawer)({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  boxSizing: 'border-box',
  [`& .${drawerClasses.paper}`]: {
    width: DRAWER_WIDTH,
    boxSizing: 'border-box',
  },
});

export default function AdminSideMenu() {
  return (
    <Drawer variant="permanent" sx={{ display: { xs: 'none', md: 'block' } }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <AdminBrand />
        <Box sx={{ flex: 1, overflow: 'auto' }}>
          <AdminMenuContent />
          <Paper
            variant="outlined"
            sx={{ mx: 2, mt: 2, p: 2, bgcolor: 'background.paper' }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
              Pending bookings?
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
              Review and confirm new court reservations.
            </Typography>
            <Button component={RouterLink} to="/admin/bookings" size="small" variant="contained" fullWidth>
              Open bookings
            </Button>
          </Paper>
        </Box>
        <AdminUserFooter />
      </Box>
    </Drawer>
  );
}
